import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import productService from '../../services/product';
import productFormService from '../../services/form';
import exciseGroupService from '../../services/exciseGroup';
import productTransformer from './../../transformers/product';
import productPackagingService from '../../services/productPackaging';

export default {
  data() {
    return {
      form: new Forms({}),
      product: {},
      loading: false,
    };
  },

  props: {
    productId: {
      type: [String, Number],
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    updated: {
      type: Function,
      required: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    isEdi: {
      type: Boolean,
      required: false,
      default: false,
    },
    destination: {
      type: Function,
      required: false,
      default: null,
    },
    destinationProps: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      currentOrder: 'currentOrder',
      groups: 'allExciseGroups',
      excisePackagingGroups: 'allExcisePackagingGroups',
      exciseBasicGroups: 'allExciseBasicGroups',
      productPackagings: 'allProductPackagings',
    }),
  },

  watch: {
  },

  mounted() {
    this.loading = true;
    productService.show(this.productId).then((product) => {
      this.loading = false;
      this.product = product;
      this.processForm(product.productTypeId, 'exciseForm');
    });
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),
    showOrderConfirm() {
      if (this.destination) {
        if (this.destinationProps) {
          this.setModalProps(this.destinationProps);
        }
        this.setModalContent(this.destination);
        return;
      }
      if (this.isEdi) {
        this.setModalContent(() => require('./../../components/ediOrderConfirm/ediOrderConfirm.vue'));
        return;
      }
      this.setModalContent(() => require('./../../components/orderConfirm/orderConfirm.vue'));
    },
    onSubmit() {
      this.form.loading = true;
      const data = Object.assign({}, this.product, this.form.data());
      productService.quickUpdate(this.productId, Object.assign({}, productTransformer.send(data), { is_excise_form: true })).then(() => {
        this.showOrderConfirm();
      }).catch((error) => {
        this.form.recordErrors(error);
        this.form.loading = false;
      });
    },

    processForm(typeId, name) {
      const self = this;
      self.loading = true;
      self.forms = [];
      Promise.all([
        productFormService.fields(typeId, name),
        exciseGroupService.all(),
        exciseGroupService.packaging(),
        exciseGroupService.basic(),
        productPackagingService.all(),
      ]).then((data) => {
        for (let i = 0; i < data[0].length; i++) {
          const fields = {};
          for (let f = 0; f < data[0][i].fields.length; f++) {
            const field = data[0][i].fields[f];

            const new_field = {
              type: field.fieldType.type,
              value: field.defaultValue,
            };

            fields[field.name] = new_field;
          }
          fields.alcoholPercentage = {
            type: 'text',
            value: '',
          };
          fields.bottleVolume = {
            type: 'text',
            value: this.product.fieldsJSON.bottleVolume,
          };
          fields.productPackagingId = {
            type: 'select',
            value: this.product.productPackagingId,
          };
          const form = new Forms(fields);
          form.setOptions('productPackagingId', this.productPackagings.all);
          Object.keys(fields).map((value, key) => {
            if (value == 'exciseAlcoholGroup') {
              form.setOptions('exciseAlcoholGroup', self.groups.map(c => ({
                id: c.id,
                name: `${c.description}`,
              })));
            } else if (value == 'excisePackagingGroup') {
              form.setOptions('excisePackagingGroup', self.excisePackagingGroups.map(c => ({
                id: c.id,
                name: `${c.description}`,
              })));
            } else if (value == 'exciseBasicGroup') {
              form.setOptions('exciseBasicGroup', self.exciseBasicGroups.map(c => ({
                id: c.id,
                name: `${c.description}`,
              })));
            }
          });
          self.form = form;
          self.form.assignData(self.product);
          self.form.alcoholPercentage = this.product.fieldsJSON.alcohol_percentage || '';
          self.form.bottleVolume = this.product.fieldsJSON.bottle_volume || '';
        }
        self.loading = false;
      });
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/quickProductEditExcise/quickProductEditExcise.js